<app-header></app-header>
<div class="hero-section section pt-0">
    <div class="container pt-5">
 
    </div>
   
  </div>

  <div class="about-section section container">
    <div class="row">
      <div class="col-12 col-lg-12 mb-3 mb-lg-0">
        <p class="display-5 fw-normal">KINATWA SACCO</p>
        <p >
          Kinatwa SACCO is a transport based SACCO with its headquarters located in Kitui. The SACCO has gained popularity in various parts of the country for its efficient service transport both ordinary fourteen capacity vans and executive – (shutles) and parcel deliveries.
The SACCO vehicle offers daily trips to the capital city of Nairobi from major towns among them Kitui ,Mwingi,Kibwezi,Makindu and very soon we are introducing the Nairobi-Mombasa Route The SACCO was formed in 2001 by matatu owners from Nairobi and Kitui at a time when the Matatu industry was known for its notoriety.
With the zeal to streamline the operations and instill discipline a group of Matatu owners pursed the incorporation and registration of KInatwa SACCO IN 2004 UNDER THE COOPERATIVES SOCIETY Act cap 490. The SACCO has upheld its core objectives of savings mobilization for owned land at affordable rates to enable members engage in their businesses profitable and improve their lively hood
        </p>
       
      </div>
      
    </div>
  </div>
  <app-footer></app-footer>
  